/** Prefixes `path` with `/stores/<teamId>` unless the caller already did. */
export function getStoreScopedPath(teamId: string, path: string): string {
  const prefix = `/stores/${teamId}`;
  if (path === prefix) {
    return prefix;
  }
  if (path.startsWith(`${prefix}/`)) {
    return path;
  }
  return prefix + path;
}

let authFlowRoots: ReadonlySet<string> | undefined;

/**
 * Registers the top-level route paths that are entered from outside a store
 * session (login, install and OAuth flows, public pages). They are never
 * store-scoped. The route tree registers them, so the set cannot drift from
 * the routes.
 */
export function registerAuthFlowRoots(roots: readonly string[]): void {
  authFlowRoots = new Set(roots);
}

function isAuthFlowPath(path: string): boolean {
  const root = new URL(path, "http://localhost").pathname.split("/")[1];
  return root !== undefined && (authFlowRoots?.has(root) ?? false);
}

/** Where login sends the merchant for `next`: into the store they just logged in to, except for auth-flow pages. */
export function scopeLoginNext(teamId: string, next: string): string {
  if (!authFlowRoots || isAuthFlowPath(next)) {
    return next;
  }
  if (next.startsWith("/stores/")) {
    const nextTeamId = new URL(next, "http://localhost").pathname.split("/")[2];
    return nextTeamId === teamId ? next : getStoreScopedPath(teamId, "");
  }
  return getStoreScopedPath(teamId, next);
}
